import React, { FC, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import getCookie from '../../../utils/getCookie';
import { IConsents, consentPopupsEvents } from '../types';
import { IConfig } from '../../../types/config';
import Styles from './styles';
import { cookies } from '../../../translates';

const enum popupTabs {
  NECESSARY = 'NECESSARY',
  ANALYTICAL = 'ANALYTICAL',
  MARKETING = 'MARKETING',
}

const tabsDescriptions = (language: string) => ({
  [popupTabs.NECESSARY]: cookies[language].configEssentialContent,
  [popupTabs.ANALYTICAL]: cookies[language].configAnalyticalContent,
  [popupTabs.MARKETING]: cookies[language].configMarketingContent,
});

const CookiesPopup: FC<{
  setCookie: (consents: IConsents) => void;
  config: IConfig;
  language: string;
}> = ({ setCookie, config, language }) => {
  const [activeTab, setActiveTab] = useState<popupTabs>(popupTabs.NECESSARY);
  const [consentsState, setConsentsState] = useState({
    [popupTabs.NECESSARY]: true,
    [popupTabs.ANALYTICAL]: false,
    [popupTabs.MARKETING]: false,
  });

  useEffect(() => {
    const cookie = getCookie('cookieConsent');
    if (cookie) {
      const consents: IConsents = JSON.parse(cookie);
      setConsentsState({
        NECESSARY: true,
        ANALYTICAL: consents.analytics_storage === 'granted',
        MARKETING: consents.ad_storage === 'granted',
      });
    }
  }, []);

  return (
    <Styles config={config.general.content} cookies={config.cookies}>
      <div className={`cookies-config-popup`}>
        <div className={`cookies-config-popup-box`}>
          <h3 className={`cookies-config-popup-title`}>{cookies[language].configHeader}</h3>
          <div className={`cookies-config-popup-content`}>
            <div className={`cookies-config-popup-tabs`}>
              <div className={`cookies-config-popup-tabs-buttons`}>
                <button
                  className={`cookies-config-popup-tabs-buttons-button ${
                    activeTab === popupTabs.NECESSARY ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab(popupTabs.NECESSARY)}
                >
                  {cookies[language].configEssentialHeader}
                </button>
                <button
                  className={`cookies-config-popup-tabs-buttons-button ${
                    activeTab === popupTabs.ANALYTICAL ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab(popupTabs.ANALYTICAL)}
                >
                  {cookies[language].configAnalyticalHeader}
                </button>
                <button
                  className={`cookies-config-popup-tabs-buttons-button ${
                    activeTab === popupTabs.MARKETING ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab(popupTabs.MARKETING)}
                >
                  {cookies[language].configMarketingHeader}
                </button>
              </div>
              <div className={`cookies-config-popup-tabs-content`}>
                <p className={`cookies-config-popup-tabs-description`}>{tabsDescriptions(language)[activeTab]}</p>
                <div
                  className={`cookies-config-popup-tabs-checkbox ${
                    activeTab === popupTabs.NECESSARY ? 'disabled' : ''
                  }`}
                >
                  <div
                    className={`cookies-config-popup-tabs-checkbox-box  ${consentsState[activeTab] ? 'checked' : ''}`}
                    onClick={() => setConsentsState({ ...consentsState, [activeTab]: !consentsState[activeTab] })}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                  </div>
                  <span className={`cookies-config-popup-tabs-checkbox-label`}>{cookies[language].configCheckBox}</span>
                </div>
              </div>
            </div>
            <div className={`cookies-config-popup-buttons`}>
              <button
                onClick={() =>
                  setCookie({
                    ad_storage: consentsState.MARKETING ? 'granted' : 'denied',
                    ad_user_data: consentsState.MARKETING ? 'granted' : 'denied',
                    ad_personalization: consentsState.MARKETING ? 'granted' : 'denied',
                    analytics_storage: consentsState.ANALYTICAL ? 'granted' : 'denied',
                    functionality_storage: 'granted',
                    personalization_storage: consentsState.ANALYTICAL ? 'granted' : 'denied',
                    security_storage: 'granted',
                  })
                }
              >
                {cookies[language].configSave}
              </button>
              <button
                onClick={() =>
                  setCookie({
                    ad_storage: 'granted',
                    ad_user_data: 'granted',
                    ad_personalization: 'granted',
                    analytics_storage: 'granted',
                    functionality_storage: 'granted',
                    personalization_storage: 'granted',
                    security_storage: 'granted',
                  })
                }
              >
                {cookies[language].configAcceptAll}
              </button>
            </div>
          </div>
          <button
            className={`cookies-config-popup-close`}
            onClick={() =>
              window.postMessage({ eventName: consentPopupsEvents.CLOSECONFIGPOPUP }, window.location.origin)
            }
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>
    </Styles>
  );
};

export default CookiesPopup;
